{
  "version": 1,
  "asset_id": "90899003-4a7d-4cb5-b9f9-bbb68b494330",
  "project_id": "d4069efb-83f9-479f-9707-e712fc5f9875",
  "url": "/__l5e/assets-v1/90899003-4a7d-4cb5-b9f9-bbb68b494330/warmtepompen-1024.avif",
  "r2_key": "a/v1/d4069efb-83f9-479f-9707-e712fc5f9875/90899003-4a7d-4cb5-b9f9-bbb68b494330/warmtepompen-1024.avif",
  "original_filename": "warmtepompen-1024.avif",
  "size": 41040,
  "content_type": "image/avif",
  "created_at": "2026-10-18T17:03:54Z"
}
